import React from "react";
import PropTypes from "prop-types";
import Chip from "@mui/material/Chip";

const UserRolesBadge = ({ status }) => {
  const getBadgeProps = () => {
    switch (status) {
      case "SuperAdmin":
        return { label: "SuperAdmin", color: "secondary" };
      case "Admin":
        return { label: "Admin", color: "error" };
      case "Editor":
        return { label: "Editor", color: "primary" };
      case "User":
        return { label: "User", color: "default" };
      case "Mitglied":
        return { label: "Mitglied", color: "info" };
      default:
        return { label: "Unknown", color: "default" };
    }
  };

  const { label, color } = getBadgeProps();

  return (
    <Chip
      label={label}
      color={color}
      variant="filled"
      size="small"
      sx={{
        fontWeight: 700,
        letterSpacing: "0.3px",
        borderRadius: "999px",
        px: 0.5,
        boxShadow: "0 6px 16px rgba(0,0,0,0.18)",
      }}
    />
  );
};

UserRolesBadge.propTypes = {
  status: PropTypes.oneOf([
    "Admin",
    "Editor",
    "User",
    "Mitglied",
    "SuperAdmin",
  ]),
};

export default UserRolesBadge;
